// extracted by mini-css-extract-plugin
export var locationCard = "_ia-0";